module.exports = __webpack_public_path__ + "img/top_img.3d2f7385.jpg";